import { VCard } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c(VCard,[_c(VContainer,{staticClass:"pa-3"},[_c('bar-chart',_vm._b({ref:"chart",attrs:{"data":_vm.data,"labels":_vm.labels,"yTitle":_vm.yTitle,"backgroundColor":_vm.backgroundColor,"datasetLabel":_vm.sourceText}},'bar-chart',_vm.$attrs,false))],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }